import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';

export default grapesjs.plugins.add('gjs-calendar-timeslot', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'calendar-timeslot',
    blocks: ['calendar-timeslot'],
    defaultStyle: true,
    label: 'Time Slot',
    category: 'Advanced',
    type: 'calendar-timeslot',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
